import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=8188912e"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"
import style0 from "./Parents.vue?vue&type=style&index=0&id=8188912e&prod&lang=scss&module=true"
import style1 from "./Parents.vue?vue&type=style&index=1&id=8188912e&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports